






























































































































































































































import Modal from '@/project/modals/Modal.vue';
import { Component } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import Accordion from '@/core/ui-components/Accordion.vue';
import authService from '@/core/auth/auth.service';
import megaMenuService from '@/project/shared/megaMenu.service';
import NavigationStore, { ClientMenuItem } from '@/project/layout/navigation/navigation.store';
import serverContextService from '@/core/serverContext.service';
import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import { PageName } from '@/router/routes/constants';
import CampaignIcon from '@/project/product/campaigns/CampaignIcon.vue';
import dictionaryService from '@/core/translation/dictionary.service';
import urlStringHelperService from '@/core/urlStringHelper.service';
import appStore from '@/core/app/app.store';

@Component({
    components: {
        Accordion,
        CampaignIcon
    }
})
export default class MobileMenu extends Modal {
    private navigation: readonly (MenuItem | ClientMenuItem)[] = [];
    private breadcrumb: (MenuItem | ClientMenuItem)[] = [];
    private activeLevel: number = 0;
    private forward = true;
    private pdpParentCategoryUrl:string | undefined = undefined;
    get favouritesPageName() {
        return PageName.MY_ACCOUNT_FAVOURITES;
    }

    get clientNavigationItems() {
        return [NavigationStore.clientNavigationItems];
    }

    get resourceNavigationItems() {
        if (!(serverContextService?.resourceMenu?.resourceMenuItemGroups?.length)) { return []; }
        const resourceMenu: ClientMenuItem = {
            name: dictionaryService.get('FrontPage.Resources'),
            url: '', // Empty url, because we don't want the page to exist,
            icon: 'resources',
            iconFill: false,
            children: ((serverContextService?.resourceMenu?.resourceMenuItemGroups?.length && serverContextService.resourceMenu.resourceMenuItemGroups) || []).map(link => {
                let groupUrl = link.groupUrl || '';
                if (urlStringHelperService.hasCulturePrefix(groupUrl)) {
                    groupUrl = urlStringHelperService.withoutCulturePrefix(groupUrl);
                }
                return {
                    name: link.headline || '',
                    url: groupUrl,
                    children: link.links?.map(subLink => {
                        let url: string = subLink.url || '';
                        if (urlStringHelperService.hasCulturePrefix(url)) {
                            url = urlStringHelperService.withoutCulturePrefix(url);
                        }
                        return {
                            name: subLink.name || '',
                            url: url
                        };
                    })
                };
            })
        };

        return [resourceMenu];
    }

    async created() {
        this.navigation = await megaMenuService.getMegaMenu();
        this.navigateToActiveNavigationItemOnDemand();
    }

    private navigateToActiveNavigationItemOnDemand(): void {
        const navigationItems = [...this.clientNavigationItems, ...this.resourceNavigationItems, ...this.navigation];

        if (this.$router.currentRoute.name === PageName.PRODUCT_DETAILS) {
            // Finding the products primary category from breadcrumb
            if (appStore.breadcrumb.length >= 2) {
                this.pdpParentCategoryUrl = appStore.breadcrumb[appStore.breadcrumb.length - 2]?.url || undefined;
            }
        }

        for (let i = 0; i < navigationItems.length; i++) {
            const navigationItem = navigationItems[i];

            if (navigationItem) {
                const activeItemTree = this.buildActiveItemTreeFor(navigationItem, []);
                if (activeItemTree && activeItemTree.length) {
                    for (let a = 0; a < activeItemTree.length; a++) {
                        this.nextLevel(activeItemTree[a]);
                    }

                    return;
                }
            }
        }
    }

    private buildActiveItemTreeFor(menuItem: ClientMenuItem | MenuItem, tree: (ClientMenuItem | MenuItem)[] = []): (ClientMenuItem | MenuItem)[] | null {
        const isClientMenuItem = Object.prototype.hasOwnProperty.call(menuItem, 'page');
        const menuItemProperty = isClientMenuItem ? 'page' : 'url';
        const currentPage = this.$route[isClientMenuItem ? 'name' : 'path'];
        if (menuItem[menuItemProperty] && (menuItem[menuItemProperty] === currentPage || menuItem[menuItemProperty] === this.pdpParentCategoryUrl)) {
            return [...tree, menuItem];
        }

        if (menuItem.children && menuItem.children.length) {
            for (const menu of menuItem.children) {
                const childTree = this.buildActiveItemTreeFor(menu, [...tree, menuItem]);
                if (childTree) {
                    const activeChild = childTree[childTree.length - 1];

                    if (activeChild) {
                        return activeChild.children && activeChild.children.length ? childTree : childTree.slice(0, childTree.length - 1);
                    }
                }
            }
        }

        return null;
    }

    private get isLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private get campaignCode() {
        return serverContextService?.settings?.menuCampaignIcon;
    }

    private get campaignLink() {
        return serverContextService?.settings?.menuCampaignLink;
    }

    get becomeACustomerPage() {
        return serverContextService?.settings?.becomeACustomerPage;
    }

    get showBecomeACustomer(): boolean {
        // Only show for users who has never been logged in - and only if page exists
        return ((!this.isLoggedIn && !authService.hasLoggedInBefore()) && !!this.becomeACustomerPage);
    }

    private get activeParent(): MenuItem | ClientMenuItem | null {
        if (!this.breadcrumb.length) return null;
        return this.breadcrumb[this.activeLevel - 1];
    }

    private clickNextLevel($event, menuItem: MenuItem | ClientMenuItem) {
        this.nextLevel(menuItem);
        if (menuItem?.children?.length) {
            $event.preventDefault();
            return false;
        }
    }

    private nextLevel(menuItem: MenuItem | ClientMenuItem) {
        this.activeLevel++;
        this.breadcrumb.push(menuItem);
        this.forward = true;
    }

    private previousLevel() {
        this.activeLevel--;
        this.breadcrumb.pop();
        this.forward = false;
    }

    private topLevel() {
        this.activeLevel = 0;
        this.breadcrumb = [];
        this.forward = false;
    }

    private get children() {
        return this.activeParent?.children ?? [];
    }

    private get enterAnimationClasses() {
        const animCls = this.forward ? 'slideInRight' : 'slideInLeft';
        return `animated ${animCls} u-anim-dur-400 u-anim-ease-in-out`;
    }

    private get leaveAnimationClasses() {
        const animCls = this.forward ? 'slideOutLeft' : 'slideOutRight';
        return `animated ${animCls} u-anim-dur-400 u-anim-ease-in-out`;
    }

    private get brandPageName() {
        return PageName.BRAND_OVERVIEW;
    }

    private clickMenuLink() {
        setTimeout(() => this.closeOverlay(), 200);
    }

    private openLogin() {
        loginFormOverlayService.show('login');
    }

    private showNavElement(item: ClientMenuItem) {
        return NavigationStore.showNavElement(item);
    }

    private classForMenuItem(item: ClientMenuItem): string | null {
        return this.pdpParentCategoryUrl && this.pdpParentCategoryUrl === item.url ? 'font-bold' : null;
    }

    private get productGuidePage() {
        return serverContextService?.settings?.productGuidePage;
    }

    private get salesAndSupportPage() {
        return serverContextService?.settings?.salesAndSupportPage;
    }
}
